define('views/content/distributor',['require','views/base/item_page_view','typeahead','bloodhound','jquery.scrollbar','views/components/reseller_product_compact/reseller_products','collections/distributor_products','views/components/reseller/resellers','collections/resellers','views/components/action_history/action_histories','collections/action_histories','models/distributor_manager','views/components/recurring_product_compact/recurring_products','collections/recurring_products','text!templates/content/distributor.html'],function(require){

    var BaseItemPageView = require('views/base/item_page_view');
    require('typeahead');
    require('bloodhound');
    require('jquery.scrollbar');

    var CompactResellerProductsView = require('views/components/reseller_product_compact/reseller_products');
    var DistributorProductsCollection = require('collections/distributor_products');


    var ReselellersView = require('views/components/reseller/resellers');
    var ReselellersCollection = require('collections/resellers');

    var ActionsView = require('views/components/action_history/action_histories');
    var ActionsCollection = require('collections/action_histories');

    var DistributorManagerModel = require('models/distributor_manager');

    var CompactRecurringProductsView = require("views/components/recurring_product_compact/recurring_products");
    var RecurringProductsCollection = require("collections/recurring_products");
  
    var temp = require("text!templates/content/distributor.html");
    return BaseItemPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'distributor-page page',
        basePath: 'distributors',
        titleKey: 'distributor',

        afterInitialize: function () {
            this.productsCollection = new DistributorProductsCollection([], {
                parameters: {
                    'distributor_id': this.model.id
                }
            });
            this.productsCollection.limit = 100;

            this.resellersCollection = new ReselellersCollection([], {
                parameters: {
                    'distributor_id': this.model.id
                }
            });

            this.actionsCollection = new ActionsCollection([], {
                parameters: {
                    'distributor_id': this.model.id
                }
            });

            this.recurringProductsCollection = new RecurringProductsCollection([],{
                parameters:{
                  'distributor_id': this.model.id
                },
            });

            this.recurringProductsCollection.limit = 10;


            // If creating a new object, add manager object to the model
            if (!this.model.get('id')) {
                this.model.set('manager', new DistributorManagerModel().attributes);
                this.model.get('manager').password = '';
                this.model.get('manager').password_confirm = '';
                if (App.user.get('country_distributor')) {
                    // If in cd context, set cd id for new distributor
                    this.model.set('country_distributor', App.user.get('country_distributor'));
                }
            }
        },

        ui: function() {
            return {
                select2Input: '[data-init-plugin="select2"]',
                mainForm : '#main-form',
                submitButton: '#submit-button',
                cityField: '.cities-typeahead',
                countrySelect: '#country',
                stateSelect: '#state',
                phoneCountrySelect: '#phone_country',
                managerPhoneCountrySelect: '#manager__phone_country',
                licenseList: '.license-list',

                walletCount: '#wallet_count',
                walletDetail: '#wallet_detail',
                changeWalletButton: '#change-walet-button',

                cdField: '.cds-typeahead',

            };
        },

        events: {
            'change form input': 'formChanged',
            'change form textarea': 'formChanged',
            'change form select': 'formChanged',

            'click @ui.submitButton': 'submitButtonClicked',
            'change @ui.countrySelect': 'countryChanged',

            'click @ui.changeWalletButton': 'changeWalletButtonClicked'
        },

        regions: function() {
            return {
                LicensesContainer: ".license-list",
                CustomersContainer: ".customer-list",
                ActionsContainer: ".action-list",
                RecurringProductContainer: ".subscription-product-list"
            };
        },
        afterRender: function () {
            var _this = this;

            if (this.model.get('id')) {
                this.LicensesContainer.show(new CompactResellerProductsView({
                    collection: this.productsCollection
                }));

                this.CustomersContainer.show(new ReselellersView({
                    collection: this.resellersCollection
                }));

                this.ActionsContainer.show(new ActionsView({
                    collection: this.actionsCollection
                }));
                
                this.RecurringProductContainer.show(new CompactRecurringProductsView({
                    collection: this.recurringProductsCollection,
                }));

            }

            if (App.user.get('is_staff')) {
                //Setup typeahed for country distributor field
                var cdsTypeahedEngine = new Bloodhound({
                    datumTokenizer: Bloodhound.tokenizers.whitespace,
                    queryTokenizer: Bloodhound.tokenizers.whitespace,
                    remote: {
                        url: App.Config.apiBase + 'country-distributors/typeahead/',
                        replace: function (url, query) {
                            return url + ('?query=' + encodeURIComponent(_this.ui.cdField.val()));
                        }
                    },
                    identify: function (obj) {
                        return obj.id;
                    }
                });

                this.ui.cdField.typeahead({
                    minLength: 3
                }, {
                    name: 'country_distributors',
                    source: cdsTypeahedEngine,
                    display: 'company_name'
                });

                // Get selected distributor's id
                this.ui.cdField.bind('typeahead:select', function (ev, suggestion) {
                    _this.model.set('country_distributor', suggestion.id);
                });

            }

            // Setup typeahed for city field
            var citiesTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'cities/typeahead/',
                    replace: function(url, query) {
                        var modifiedUrl = url + ('?query=' + _this.ui.cityField.val());

                        if (_this.model.get('country')) {
                            modifiedUrl += ('&country=' + _this.model.get('country'));
                        }

                        return modifiedUrl;
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.cityField.typeahead({
                minLength: 3
            }, {
                name: 'cities',
                source: citiesTypeahedEngine,
                display: 'name'
            });
            // Get selected cities name
            this.ui.cityField.bind('typeahead:select', function (ev, suggestion) {
                _this.model.set('city_name', suggestion.name);
            });
            
            this.ui.licenseList.scrollbar();
        },

        setupFormValidation: function () {
            this.ui.mainForm.validate({
                rules: {
                    'cd_object__company_name': "required",
                    'company_name': "required",
                    'country': "required",
                    'city_name': "required",
                    'phone_country': "required",
                    'phone_value': "required",
                    'foundation_year': "required",
                    'service_languages': "required",
                    "service_types": "required",
                    'address': "required",
                    'group': "required",

                    'manager__first_name': "required",
                    'manager__last_name': "required",
                    'manager__email': "required",
                    'manager__phone_country': "required",
                    'manager__phone_value': "required",
                    'manager__password': "required",
                    'manager__password_confirm': {
                        equalTo: '[name="manager__password"]'
                    }
                },
                messages: {
                    'cd_object__company_name': App.polyglot.t('cd_required'),
                    'company_name': App.polyglot.t('company_name_required'),
                    'country': App.polyglot.t('country_required'),
                    'city_name': App.polyglot.t('city_required'),
                    'phone_country': App.polyglot.t('phone_country_required'),
                    'phone_value': App.polyglot.t('phone_value_required'),
                    'foundation_year': App.polyglot.t('foundation_year_required'),
                    'service_languages': App.polyglot.t('service_languages_required'),
                    "service_types": App.polyglot.t('service_types_required'),
                    'address': App.polyglot.t('address_required'),
                    'group': App.polyglot.t('group_required'),

                    'manager__first_name': App.polyglot.t('manager_first_name_required'),
                    'manager__last_name': App.polyglot.t('manager_last_name_required'),
                    'manager__email': App.polyglot.t('manager_email_required'),
                    'manager__phone_country': App.polyglot.t('manager_phone_country_required'),
                    'manager__phone_value': App.polyglot.t('manager_phone_value_required'),
                    'manager__password': App.polyglot.t('password_required'),
                    'manager__password_confirm': {
                        equalTo: App.polyglot.t('password_confirm_must_match')
                    }

                },

                onfocusout: false,
                onkeyup: false,
                onclick: false,

                showErrors: function (errorMap, errorList) {
                    for (var i=0; i<errorList.length; i++) {
                        App.utils.showMessage('error', errorList[i].message);
                    }
                }
            });
        },

        countryChanged: function () {
            var country_id = this.ui.countrySelect.val();

            if (country_id) {
                // Select same country in phone number field
                this.ui.phoneCountrySelect.val(country_id);
                this.ui.phoneCountrySelect.trigger('change');
                this.ui.managerPhoneCountrySelect.val(country_id);
                this.ui.managerPhoneCountrySelect.trigger('change');

                // Reset state and re render for state options of country
                this.ui.stateSelect.val(null);
                this.ui.stateSelect.trigger('change');
                this.render();
            }
        },


        changeWalletButtonClicked: function () {
            var _this = this;

            var walletCount = this.ui.walletCount.val();
            var walletDetail = this.ui.walletDetail.val();

            if (walletCount >= 0 && walletDetail.length > 10) {
                _this.ui.changeWalletButton.addClass('loading');

                $.ajax({
                    url: App.Config.apiBase + 'distributors/' + this.model.get('id') + '/set_distributor_wallet/',
                    method: 'post',
                    data: {
                        wallet: walletCount,
                        note: walletDetail
                    },
                    success: function (response) {
                        _this.ui.changeWalletButton.removeClass('loading');
                        _this.model.set(response);
                        _this.render();

                        App.utils.showMessage('success', App.polyglot.t('update_wallet_success'));
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        _this.ui.changeWalletButton.removeClass('loading');

                        // Show error messages
                        if (xhr.responseJSON.errors) {
                            for (var i = 0; i < xhr.responseJSON.errors.length; i++) {
                                App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                            }
                        }
                    }
                });
            } else {
                if (walletCount < 0) {
                    App.utils.showMessage('error', App.polyglot.t('wallet_must_be_greater_than_zero'));
                }
                if (walletDetail.length <= 10) {
                    App.utils.showMessage('error', App.polyglot.t('note_length_must_be_greater_than_ten'));
                }
            }
        },

    });
});
